import { Component, Input, OnInit, CUSTOM_ELEMENTS_SCHEMA, AfterViewInit } from '@angular/core';
import { getInformation } from '../../constants/ci-information.constant';
import { NgClass, NgFor, NgIf } from '@angular/common';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'app-information-preview',
  standalone: true,
  templateUrl: './information-preview.component.html',
  imports: [NgIf, NgClass, NgFor, RouterModule],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class InformationPreviewComponent implements OnInit, AfterViewInit {

  @Input()
  public slug!: string;

  @Input()
  public invert!: boolean;

  @Input()
  public scrollSectionId!: string;

  public data: any;

  constructor() {
  }

  ngOnInit(): void {
    this.data = getInformation(this.slug);
  }

  ngAfterViewInit(): void {
    this.scrollToTop();
  }

  public scrollToTop() {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }

  public scrollToFeatureSection(): any {
    const element = document.getElementById(this.scrollSectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  }
}
